module.exports = __webpack_public_path__ + "img/bar.bc53246a.svg";